import type { ReactNode } from 'react';

export const symbol_home_app_logo: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-430ZM233-120q-47.08 0-80.04-32.96Q120-185.92 120-233v-247q0-22.59 8.49-43.29Q136.97-544 153-560l248-247q17-17 37.51-25 20.52-8 41.49-8 21.65 0 42.35 8.01Q543.06-823.97 560-807l247 247q16.03 16 24.51 36.71Q840-502.59 840-480v247q0 47.08-32.67 80.04Q774.67-120 728-120H233Zm0-60h495q22.1 0 37.05-15.5Q780-211 780-233v-247q0-10.91-3.5-20.45Q773-510 765-518L599-684l-76 76 152 153v170H285v-170l271-271-39.06-38.57q-10.41-10.29-20.18-12.86Q487-780 480.5-780q-6.5 0-17 2.5T443-765L196-518q-8 8.14-12 17.64T180-480v247q0 22 15.5 37.5T233-180Zm112-165h270v-85L480-565 345-430v85Z"
		/>
	</svg>
);
